import {
    Breakpoints,
    getWindowWidth,
} from '@zocdoc-frontend-common/styles-grid';

export default function isMobileOrTabletBreakpoint() {
    return getWindowWidth() < Breakpoints.medium;
}
